webpackJsonp([2],{

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  max-width: 1000px;\n  margin: auto;\n  width: 80%;\n  margin-top: 10%;\n  background-color: #150a1c;\n  height: auto;  \n  padding: 25px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n'], ['\n  max-width: 1000px;\n  margin: auto;\n  width: 80%;\n  margin-top: 10%;\n  background-color: #150a1c;\n  height: auto;  \n  padding: 25px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    text-align: right;\n    width: 100%;\n    background-color: #150a1c;\n    padding: 10px 5px 0 0;\n    margin: 10px 0;\n    @media (max-width:641px)  { /* portrait tablets, portrait iPad, landscape e-readers, landscape 800x480 or 854x480 phones */\n        text-align: center;\n        width: 100%;\n        padding: 10px 5px 0px 0px;\n        margin: 10px 0px;\n      }\n'], ['\n    text-align: right;\n    width: 100%;\n    background-color: #150a1c;\n    padding: 10px 5px 0 0;\n    margin: 10px 0;\n    @media (max-width:641px)  { /* portrait tablets, portrait iPad, landscape e-readers, landscape 800x480 or 854x480 phones */\n        text-align: center;\n        width: 100%;\n        padding: 10px 5px 0px 0px;\n        margin: 10px 0px;\n      }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    color: #FF00EA;\n    display: inline-block;\n    text-decoration: none;\n    font-size: 20px;\n    font-family: Lato, sans-serif;\n    font-weight:\'300\';\n'], ['\n    color: #FF00EA;\n    display: inline-block;\n    text-decoration: none;\n    font-size: 20px;\n    font-family: Lato, sans-serif;\n    font-weight:\'300\';\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(21);

var _styledComponents = __webpack_require__(45);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var PageContent = _styledComponents2.default.div(_templateObject);
var Nav = _styledComponents2.default.nav(_templateObject2);

var NavLink = _styledComponents2.default.div(_templateObject3);

var styles = {
    navA: _defineProperty({
        color: '#FF00EA',
        padding: '1rem',
        display: 'inlineBlock',
        textDecoration: 'none',
        fontWeight: 'bold',
        fontSize: '20px',
        fontFamily: 'Lato, sans-serif',
        margin: '5px'
    }, 'fontWeight', '300')
};

var ActiveStyle = {
    fontWeight: 'bold',
    color: '#108db8'
};

exports.default = function (_ref) {
    var children = _ref.children;
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            Nav,
            null,
            _react2.default.createElement(
                NavLink,
                null,
                _react2.default.createElement(
                    _reactStatic.Link,
                    { style: styles.navA, to: '/' },
                    'Home'
                )
            ),
            _react2.default.createElement(
                NavLink,
                null,
                _react2.default.createElement(
                    _reactStatic.Link,
                    { style: styles.navA, to: '/about', activeStyle: ActiveStyle },
                    'About'
                )
            ),
            _react2.default.createElement(
                NavLink,
                null,
                _react2.default.createElement(
                    _reactStatic.Link,
                    { style: styles.navA, to: '/blog', activeStyle: ActiveStyle },
                    'Blog'
                )
            ),
            _react2.default.createElement(
                NavLink,
                null,
                _react2.default.createElement(
                    _reactStatic.Link,
                    { style: styles.navA, to: '/projects', activeStyle: ActiveStyle },
                    'Projects'
                )
            )
        ),
        _react2.default.createElement(
            PageContent,
            { className: '' },
            children
        )
    );
};

/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    color:#FF00EA;\n    background: linear-gradient(135deg, #FF00EA, #8F018F, #07E2FF, #5900FF);\n    background: -o-linear-gradient(135deg, #FF00EA, #8F018F, #07E2FF, #5900FF);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    font-family: \'Raleway\', sans-serif;\n    font-size: 3em;\n    text-align: center;  \n    margin: auto;\n    margin-bottom: 5%;\n    @media (max-width:320px) {\n      font-size: 2em;\n    }\n'], ['\n    color:#FF00EA;\n    background: linear-gradient(135deg, #FF00EA, #8F018F, #07E2FF, #5900FF);\n    background: -o-linear-gradient(135deg, #FF00EA, #8F018F, #07E2FF, #5900FF);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    font-family: \'Raleway\', sans-serif;\n    font-size: 3em;\n    text-align: center;  \n    margin: auto;\n    margin-bottom: 5%;\n    @media (max-width:320px) {\n      font-size: 2em;\n    }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  width: 100%;\n  color: white;\n  padding: initial;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n'], ['\n  width: 100%;\n  color: white;\n  padding: initial;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  height: auto;\n  border: solid 1px white;\n  margin: 0 0 50px ;\n'], ['\n  height: auto;\n  border: solid 1px white;\n  margin: 0 0 50px ;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  width: auto;\n  overflow: hidden;\n  min-width:auto;\n  display: flex;\n  flex-direction: column;\n'], ['\n  width: auto;\n  overflow: hidden;\n  min-width:auto;\n  display: flex;\n  flex-direction: column;\n']),
    _templateObject5 = _taggedTemplateLiteral([' \n  width: 100%; \n'], [' \n  width: 100%; \n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  line-height: 1.3;\n  margin: 20px;\n  color: white;\n'], ['\n  line-height: 1.3;\n  margin: 20px;\n  color: white;\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  border: 10px;\n  margin: 5px;\n  padding: 5px;\n  font-family: Roboto, sans-serif;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0); \n  cursor: pointer; \n  text-decoration: none;\n  min-width: 88px;\n  color: #ffffff;\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n  border-radius: 2px;\n  background-color: #bd9def;\n'], ['\n  border: 10px;\n  margin: 5px;\n  padding: 5px;\n  font-family: Roboto, sans-serif;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0); \n  cursor: pointer; \n  text-decoration: none;\n  min-width: 88px;\n  color: #ffffff;\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n  border-radius: 2px;\n  background-color: #bd9def;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PageLayout = __webpack_require__(142);

var _PageLayout2 = _interopRequireDefault(_PageLayout);

var _styledComponents = __webpack_require__(45);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ProjectsTitle = _styledComponents2.default.h2(_templateObject);
var ProjectsDiv = _styledComponents2.default.div(_templateObject2);
var ProjectItem = _styledComponents2.default.li(_templateObject3);
var ProjectItemHeader = _styledComponents2.default.div(_templateObject4);
var ProjectItemHeaderImg = _styledComponents2.default.img(_templateObject5);
var ProjectItemContent = _styledComponents2.default.div(_templateObject6);
var ProjectLink = _styledComponents2.default.a(_templateObject7);

exports.default = function () {
  return _react2.default.createElement(
    _PageLayout2.default,
    null,
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        ProjectsTitle,
        null,
        'Projects'
      ),
      _react2.default.createElement('br', null),
      _react2.default.createElement(
        ProjectsDiv,
        null,
        _react2.default.createElement(
          ProjectItem,
          { className: 'project-post' },
          _react2.default.createElement(
            ProjectItemHeader,
            null,
            _react2.default.createElement(ProjectItemHeaderImg, { src: '/uploads/projects/HTMLCanvas-project.png', alt: 'HTMLCanvas-project' })
          ),
          _react2.default.createElement(
            ProjectItemContent,
            null,
            _react2.default.createElement(
              'h3',
              null,
              'HTML Canvas'
            ),
            _react2.default.createElement(
              'h2',
              null,
              'March 2016'
            ),
            _react2.default.createElement(
              'p',
              null,
              'As a web developer I think it\'s important to be able to share your ideas and collaborate on tasks with your team.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'HTML Canvas allows users to create, render and share fully functional HTML, CSS and Javascript code within the Hipchat sidebar.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Through real time collaborative editing, it aids agile collaboration and rapid evolution of ideas.'
            ),
            _react2.default.createElement(
              ProjectLink,
              { role: 'link', href: 'https://marketplace.atlassian.com/plugins/html-canvas-add-on/cloud/overview', tabindex: '0', type: 'button' },
              'Project URL'
            )
          )
        ),
        _react2.default.createElement(
          ProjectItem,
          { className: 'project-post' },
          _react2.default.createElement(
            ProjectItemHeader,
            null,
            _react2.default.createElement(ProjectItemHeaderImg, { src: '/uploads/projects/bottle-project.png', alt: 'Bottle-project' })
          ),
          _react2.default.createElement(
            ProjectItemContent,
            null,
            _react2.default.createElement(
              'h3',
              null,
              'Bottle'
            ),
            _react2.default.createElement(
              'h2',
              null,
              'January 2016'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Bottle is a messaging application that allows users to send and receive anonymous messages.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'It is styled around the idea of sending a message in a bottle. Each message will be received as a bottle that has arrived at the shoreline.'
            ),
            _react2.default.createElement(
              ProjectLink,
              { role: 'link', href: 'https://play.google.com/store/apps/details?id=com.techronomicongames.bottle', tabindex: '0', type: 'button' },
              'Project URL'
            )
          )
        )
      )
    )
  );
};

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/Projects.ef2e4304.js